import {useState, useContext, useEffect} from "react";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import NivelesEstructureContext from "context/NivelesEstructureContext";
import ErrorMessage from "components/ErrorMessage";

const NIVELESESTRUCTURE_VALUES = {
	nivel: "",
	tramas: "[]",
	flujo: ""
};

function Form({createNivelEstructure, updateNivelEstructure, setIsSearched}) {


	const {
		nivelEstructure: selectedNivelEstructure,
		setNivelEstructure: setSelectedNivelEstructure,
		message,
		setMessage,
	} = useContext(NivelesEstructureContext);

	const [form, setForm] = useState(NIVELESESTRUCTURE_VALUES);
	const {nivel, tramas, flujo} = form;

	let myAbi = HelpAbility();
	const handleChange = (e) => {
		setForm({...form, [e.target.name]: e.target.value});
	};

	const handleChangeBool = (e) => {
		console.log(e.target.value);
		setForm({...form, [e.target.name]: e.target.value});
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		const newForm = {
			nivel: form.nivel,
			tramas: JSON.parse(form.tramas),
			flujo: form.flujo
		}
		let status = Object.keys(selectedNivelEstructure).length
			? await updateNivelEstructure({
					nivel: newForm,
					id: selectedNivelEstructure._id,
			  })
			: await createNivelEstructure({nivel: newForm});
		if (!status) {
			setIsSearched({
				search: "",
				option: "",
				state: false,
			});
			setForm(NIVELESESTRUCTURE_VALUES);
			setSelectedNivelEstructure({});
			setMessage({message: "", status: 200});
		}
	};

	const handleReset = () => {
		setForm(NIVELESESTRUCTURE_VALUES);
		setSelectedNivelEstructure({});
		setMessage({message: "", status: 200});
	};

	const isVisibleForm = Object.keys(selectedNivelEstructure).length
		? myAbi.has(C.A.NIVELESSTRUCTURE.UPDATE)
		: myAbi.has(C.A.NIVELESSTRUCTURE.CREATE);

	useEffect(() => {
		if (!Object.keys(selectedNivelEstructure).length) return null;
		setForm(selectedNivelEstructure);
	}, [selectedNivelEstructure]);

	return (
		<>
			{isVisibleForm && (
				<div className="mt-4">
					<div className="row mb-2">
						<h6>
							{Object.keys(selectedNivelEstructure).length
								? "Editar"
								: "Agregar"}{" "}
							Nivel
						</h6>
					</div>
					{message.status !== 200 && message.message && (
						<ErrorMessage message={message.message}></ErrorMessage>
					)}
					<div
						className="table-responsive rounded-3"
						style={{border: "1px solid black", paddingTop: "15px"}}
					>
						<div className="row mb-3 d-flex justify-content-center">
							<div
								className="col-2 themed-grid-col"
							>
								<label
									htmlFor="nivel"
									className="form-label"
								>
									Nivel
								</label>
								<input type="text" className="form-control" id="nivel" name="nivel" autoComplete="off" value={nivel} onChange={handleChange} placeholder="MZ_TIPO_NIVEL1" />
							</div>
							<div
								className="col-4 themed-grid-col"
							>	
								<label
									htmlFor="tramas"
									className="form-label mb-0"
								>
									Tramas
								</label>
								<textarea  type="text" className="form-control" id="tramas" name="tramas" autoComplete="off" value={tramas} onChange={handleChange} placeholder="[{'nombre':'MANZANA','valores':'10-15,10-16,10-7B'}]" rows="10">{tramas}</textarea>
								
							</div>

								<div
								className="col-2 themed-grid-col"
							>
								<label
									htmlFor="flujo"
									className="form-label"
								>
									Tipo de Flujo
								</label>
								<div className="form-check">
									<input className="form-check-input" type="radio" name="flujo"
											onChange={handleChangeBool}
											checked={flujo === "barrio-manzana"} id="isVisible-radio-true"
											value={"barrio-manzana"}/>
									<label className="form-check-label" htmlFor="isVisible-radio-true">Barrio Manzana</label>
								</div>
								<div className="form-check">
									<input className="form-check-input" type="radio" name="flujo"
											onChange={handleChangeBool}
											checked={flujo === "calle-carrera"} id="isVisible-radio-false"
											value={"calle-carrera"}/>
									<label className="form-check-label" htmlFor="isVisible-radio-false">Calle Carrera</label>
								</div>
							</div>

							<div
								className="col-3 themed-grid-col ms-2"
							>
								<button
									className={
										"d-block d-block w-100 mb-2 btn btn-" +
										(true ? "success" : "primary")
									}
									type="submit"
									onClick={handleSubmit}
								>
									<i className="bi bi-save" />
									{Object.keys(selectedNivelEstructure).length
										? "Actualizar"
										: "Guardar"}
								</button>
								<button
									type="reset"
									className="d-block w-100 btn btn-secondary"
									onClick={handleReset}
								>
									<i className="bi bi-eraser" /> Limpiar
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
}
export default Form;
